import React from 'react'
import moment from 'moment'
import { Label, Table } from 'semantic-ui-react'

const OrderCreatedAt = ({ createdAt, deliveryAt, pickupAt, deliveredAt, isDelivered }) => {
  const updatedAt = isDelivered ? deliveredAt : Date.now()
  let deliveryRemaining = deliveryAt - updatedAt
  let pickupRemaining = pickupAt - updatedAt

  deliveryRemaining = parseInt(deliveryRemaining / 60000, 10)
  pickupRemaining = parseInt(pickupRemaining / 60000, 10)

  const remaining = pickupRemaining + deliveryRemaining

  const color = remaining < 0 ? { color: 'red' } : {}

  return (
    <Table.Cell>
      <div style={{ textAlign: 'center' }}>
        <span style={{ color: 'rgba(208, 62, 62, 1)' }}>{moment(createdAt).fromNow()}</span>
        <br />
        {moment(createdAt).format('HH:mm a')}
        <br />
        {moment(createdAt).format('DD-MMM-YYYY')}
        <br />
        <Label {...color} style={{ marginTop: 5 }}>
          ETA: {remaining} minutes
        </Label>
      </div>
    </Table.Cell>
  )
}

export default OrderCreatedAt



// WEBPACK FOOTER //
// ./src/containers/express/components/OrderedAtCell.js